import { __extends } from "tslib";
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { ControlTypes } from './сontrol-types';
import { noop } from './utilites';
import { AbstractControl } from './abstract-control';
var FormControl = /** @class */ (function (_super) {
    __extends(FormControl, _super);
    function FormControl(
    /**
     * Initializing valueI
     * / Инициализирующие значение или его getter
     */
    valueOrGetter, 
    /**
     * Options
     * / Опции
     */
    options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e, _f, _g;
        var _this = _super.call(this, (_a = options.activate) !== null && _a !== void 0 ? _a : null, options.additionalData, ControlTypes.Control) || this;
        Object.defineProperty(_this, "reactionOnValueGetterDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "reactionOnInternalValueDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "reactionOnIsActiveDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "reactionOnIsDirtyDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "reactionOnIsFocusedDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "validators", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "setValidValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "onChangeValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "callSetterOnInitialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "callSetterOnReinitialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isInitializedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "isInitializedActived", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // @ts-ignore: internalValue is always initialized in this.setInitialValue() call
        Object.defineProperty(_this, "internalValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "isTouched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "isFocused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "setInitialValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (valueOrGetter) {
                var valueGetter = valueOrGetter instanceof Function ? valueOrGetter : function () { return valueOrGetter; };
                _this.reactionOnValueGetterDisposer && _this.reactionOnValueGetterDisposer();
                _this.reactionOnValueGetterDisposer = reaction(valueGetter, function (initialValue) {
                    _this.reactionOnInternalValueDisposer && _this.reactionOnInternalValueDisposer();
                    _this.internalValue = initialValue;
                    _this.reactionOnInternalValueDisposer = reaction(function () { return _this.internalValue; }, function () {
                        _this.onChangeValue(_this.internalValue);
                        _this.isDirty = true;
                        _this.serverErrors = [];
                        _this.onChange.call(_this);
                        _this.checkInternalValue(true);
                    });
                    _this.onChange.call(_this);
                    _this.checkInternalValue(_this.isInitialized ? _this.callSetterOnReinitialize : _this.callSetterOnInitialize);
                    _this.isInitializedValue = true;
                }, { fireImmediately: true });
                return _this;
            }
        });
        Object.defineProperty(_this, "executeAsyncValidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (validator) {
                return _this.baseExecuteAsyncValidation(validator, function () { return _this.checkInternalValue(true); });
            }
        });
        /**
        * Set marker "Value has changed"
        * / Установить маркер "Значение изменилось"
        */
        Object.defineProperty(_this, "setDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (dirty) {
                _this.isDirty = dirty;
                return _this;
            }
        });
        /**
         * Set marker "field was in focus"
         * / Установить маркер "Поле было в фокусе"
         */
        Object.defineProperty(_this, "setTouched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (touched) {
                _this.isTouched = touched;
                return _this;
            }
        });
        Object.defineProperty(_this, "setFocused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (focused) {
                _this.isFocused = focused;
                return _this;
            }
        });
        Object.defineProperty(_this, "dispose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _super.prototype.dispose.call(_this);
                _this.reactionOnValueGetterDisposer && _this.reactionOnValueGetterDisposer();
                _this.reactionOnInternalValueDisposer && _this.reactionOnInternalValueDisposer();
                _this.reactionOnIsActiveDisposer();
                _this.reactionOnIsDirtyDisposer();
                _this.reactionOnIsFocusedDisposer();
            }
        });
        Object.defineProperty(_this, "checkInternalValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (shouldCallSetter) {
                _this.inProcessing = true;
                _this.serverErrors = [];
                _this.onValidation(_this.validators, function () { return _this.checkInternalValue(true); }, function () {
                    if (shouldCallSetter && _this.setValidValue && _this.errors.length === 0) {
                        _this.setValidValue(_this.internalValue);
                    }
                    _this.inProcessing = false;
                });
            }
        });
        makeObservable(_this, {
            processing: computed,
            internalValue: observable,
            value: computed,
            invalid: computed,
            isDirty: observable,
            dirty: computed,
            isTouched: observable,
            touched: computed,
            isFocused: observable,
            focused: computed,
            setDirty: action,
            setTouched: action,
            setFocused: action,
            checkInternalValue: action,
        });
        _this.validators = (_b = options.validators) !== null && _b !== void 0 ? _b : [];
        _this.setValidValue = (_c = options.onChangeValidValue) !== null && _c !== void 0 ? _c : noop;
        _this.onChangeValue = (_d = options.onChangeValue) !== null && _d !== void 0 ? _d : noop;
        _this.additionalData = (_e = options.additionalData) !== null && _e !== void 0 ? _e : null;
        _this.callSetterOnInitialize = (_f = options.callSetterOnInitialize) !== null && _f !== void 0 ? _f : true;
        _this.callSetterOnReinitialize = (_g = options.callSetterOnReinitialize) !== null && _g !== void 0 ? _g : false;
        _this.reactionOnIsActiveDisposer = reaction(function () { return _this.active; }, function (active) {
            _this.serverErrors = [];
            if (active) {
                _this.checkInternalValue(_this.isInitialized || _this.callSetterOnInitialize);
            }
            _this.isInitializedActived = true;
            _this.onChange.call(_this);
        });
        _this.reactionOnIsDirtyDisposer = reaction(function () { return _this.dirty; }, function (isDirty) {
            if (isDirty) {
                _this.serverErrors = [];
            }
        });
        _this.reactionOnIsFocusedDisposer = reaction(function () { return _this.focused; }, function (isFocused) {
            if (!isFocused) {
                _this.serverErrors = [];
            }
        });
        _this.setInitialValue(valueOrGetter);
        return _this;
    }
    Object.defineProperty(FormControl.prototype, "isInitialized", {
        get: function () {
            return this.isInitializedValue || this.isInitializedActived;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "processing", {
        get: function () {
            return this.inProcessing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "value", {
        get: function () {
            return this.internalValue;
        },
        set: function (value) {
            this.internalValue = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "invalid", {
        get: function () {
            return this.active && (this.errors.length > 0 || this.serverErrors.length > 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "dirty", {
        get: function () {
            return this.isDirty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "touched", {
        get: function () {
            return this.isTouched;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "focused", {
        get: function () {
            return this.isFocused;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "runInAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (action) {
            var _this = this;
            this.reactionOnValidatorDisposers.push(reaction(function () { return action(); }, function () { return _this.checkInternalValue(true); }));
        }
    });
    ;
    return FormControl;
}(AbstractControl));
export { FormControl };
//# sourceMappingURL=form-control.js.map